import ClosableElement from '../closable-element'

class Menu {
	constructor() {
        this._init()
    }    
	_init() {        
        this.el = document.querySelector('[data-menu]')
        this.elAction = document.querySelector('[data-menu-action]')
        if(this.el) {
            // window.addEventListener("resize", () => this.onResize())
            if (this.elAction) {
                this.elAction.addEventListener("click", () => this.onClick())
            }
            this.el.closable = new ClosableElement([this.el, this.elAction], () => {
                if(this.isOpen())
                {
                    // console.log('close')
                    this.close()
                }
            })
        }
    }
    close(animate = true) {
        if(animate) {
            this.el.classList.add("header-nav-is-closing")
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => this.el.classList.remove("header-nav-is-closing"), 300)
        }
        this.el.classList.remove("header-nav-is-active")
        this.elAction.classList.remove("drop-down-button-is-active")
    }
    open() {
        this.el.classList.add("header-nav-is-active")
        this.elAction.classList.add("drop-down-button-is-active")
    }
    onClick() {
        if(this.isOpen()) {
            this.close()
        } else {
            this.open()
        }
    }
    isOpen() {
        return this.el.classList.contains("header-nav-is-active")
    }
    onResize() {
        if(!window.matchMedia("only screen and (min-width: 1024px)").matches) {
            this.close(false)
        }
    }
}

export default Menu